import type { AppDispatch, RootState } from "store";
import websocketService from "services/websocket";
import {
  selectTool, removeTool, resetTools,
  updateToolMainLine, updateToolBackground, updateToolFibonacci,
  updateInstanceCoordinates,
} from "./drawingSlice";
import type {
  DrawingToolName, DrawingCoordinates,
  MainLineSettings, BackgroundSettings, FibonacciSettings,
} from "./types";
import { computeInitialCoordinates } from "./computeInitialCoordinates";

type Thunk = (dispatch: AppDispatch, getState: () => RootState) => void;

const syncToServer = (_dispatch: AppDispatch, getState: () => RootState): void => {
  const { instances } = getState().drawing;
  websocketService.saveUserSettings({ drawing_instances: instances });
};

export const addDrawingTool = (name: DrawingToolName): Thunk => (dispatch, getState) => {
  dispatch(selectTool(name));
  const state = getState();
  const newInstance = state.drawing.instances.at(-1);
  const initialCoords = computeInitialCoordinates(name, state);
  if (initialCoords && newInstance) {
    dispatch(updateInstanceCoordinates({ id: newInstance.id, coordinates: initialCoords }));
  }
  syncToServer(dispatch, getState);
};

export const removeDrawingTool = (id: string): Thunk => (dispatch, getState) => {
  dispatch(removeTool(id));
  syncToServer(dispatch, getState);
};

export const clearDrawingTools = (): Thunk => (dispatch, getState) => {
  dispatch(resetTools());
  syncToServer(dispatch, getState);
};

export const saveDrawingToolSettings = (params: {
  id: string;
  mainLine: MainLineSettings;
  fibonacci?: FibonacciSettings;
  background?: BackgroundSettings;
}): Thunk => (dispatch, getState) => {
  dispatch(updateToolMainLine({ id: params.id, mainLine: params.mainLine }));
  if (params.fibonacci) dispatch(updateToolFibonacci({ id: params.id, fibonacci: params.fibonacci }));
  if (params.background) dispatch(updateToolBackground({ id: params.id, background: params.background }));
  syncToServer(dispatch, getState);
};

export const updateDrawingCoordinates = (id: string, coordinates: DrawingCoordinates): Thunk => (dispatch, getState) => {
  dispatch(updateInstanceCoordinates({ id, coordinates }));
  syncToServer(dispatch, getState);
};
